import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

function SidebarDivider({ pinnedMenusTotal }) {
  const canShowDivider = useMemo(() => pinnedMenusTotal > 0, [pinnedMenusTotal]);

  if (canShowDivider) {
    return (
      <div 
        className="divider"
      />
    );
  }
  
  
  return <></>;
}

SidebarDivider.propTypes = {
  pinnedMenusTotal: PropTypes.number.isRequired,
};

export default memo(SidebarDivider);